import { Box } from "@chakra-ui/react"

type BarProps = {
    children: any;
}

export const Bar = ({children}: BarProps) => {

    return (
        <Box 
            bg="rgb(43, 108, 176)" 
            w="100%" 
            p={2} 
            minH={14} 
            position="relative"
            display="flex" 
            justifyContent="space-between" 
            alignItems="center"
            color="white"
        >
            {children}
        </Box>
    )
}